// extracted by mini-css-extract-plugin
module.exports = {"tabs":"KJppDXfWFIBqcAaLOa322","tab":"_14Nf_aG77l7zzpocb1pL2Q","textMiddle":"_1z3r48hRVCwb41oUEuxk5h","disabled":"_3DPMmS4wEkx0KkxLeBAeJZ","active":"_3H3-yc_g86MUc2x2ldfws0"};